import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import notes from './notes/notesSlice'
import chat from './chat/chatSlice'
import mockups from './mockups/mockupsSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        locale,
        chat,
        mockups,
        notes,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
